import { useCallback } from "react";
import { SavingItem } from "../types/types";
import backend from "../backend";
import { useOpenItemsContext } from "../context/OpenItemsContext";
import { useAdventureDataContext } from "../context/AdventureDataContext";
import { isSystemItem, systemItems } from "../biz/systemItems";

export const useItemCrudGlue = (
  adventureId: string,
) => {
  const { setEditProtection, reconstituteOpenItems, setSelectedItemId } = useOpenItemsContext();
  const { reloadItems } = useAdventureDataContext();

  const createItem = useCallback((savedItem: SavingItem, parentId?: string) => {
    (async () => {
      const saveResponse = await backend.insertItem(adventureId, savedItem);
      if (!saveResponse.ok) {
        return;
      }
      const realId = (await saveResponse.json()).id;
      setEditProtection(savedItem.id, false);
      if (parentId) {
        const setParentResponse = await backend.setParent(adventureId, realId, parentId);
        if (!setParentResponse.ok) {
          return;
        }
      }
      const items = await reloadItems();
      reconstituteOpenItems(items.quests, items.peopleAndOrgs, items.places, items.misc, items.logEntries, systemItems, realId);
      setSelectedItemId(realId);
    })();
  }, [adventureId, reloadItems, setEditProtection, reconstituteOpenItems, setSelectedItemId]);

  const deleteItem = useCallback((itemId: string) => {
    if (isSystemItem(itemId)) {
      return; // System item, not deletable
    }
    (async () => {
      const deleteResponse = await backend.deleteItem(adventureId, itemId);
      if (!deleteResponse.ok) {
        return;
      }
      const items = await reloadItems();
      reconstituteOpenItems(items.quests, items.peopleAndOrgs, items.places, items.misc, items.logEntries, systemItems);
    })();
  }, [adventureId, reloadItems, reconstituteOpenItems]);
  
  return { createItem, deleteItem };
};